const translations = {
    spray: 'Spray',
    spread: 'Spread',
    unrecognized: 'Unknown'
};

export default translations;
